import { useMobileMediaQuery } from "hooks";
import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";

export const Loader: React.FC = () => {
  const isMobile = useMobileMediaQuery();

  return (
    <Container>
      <Skeleton
        height={25}
        width={isMobile ? 250 : 500}
        style={{ marginBottom: 5 }}
      />
      <Skeleton height={isMobile ? 15 : 20} width={isMobile ? 180 : 280} />
      <Skeleton height={isMobile ? 15 : 20} width={isMobile ? 150 : 150} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0 7px;

  ${({ theme }) => theme.media.mobile} {
    margin-bottom: 65px;
  }
`;
